export const DownloadIcon = () => (
    <svg id="Download" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.28 38.7" fill="#fff" width="16px" height="16px"><g id="Set_of_Buttons"><g><polygon points="22.27 13.35 22.27 0 10.59 0 10.59 13.35 1.29 13.35 16.43 31.22 31.57 13.35 22.27 13.35"/><polygon points="31.4 29.28 26.05 34.63 8.23 34.63 2.88 29.28 0 32.16 6.52 38.68 6.52 38.7 27.73 38.7 34.28 32.16 31.4 29.28"/></g></g></svg>
);

export const ChevronIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="16" height="16" fill="currentColor">
        <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
    </svg>
);

export const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
        <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
    </svg>
);